<template>
  <div id="inse-real" style=" overflow: hidden">
    <div class="inseReal-data">
      <div class="meteReal-data-head">
        <div class="inseReal-head-left">
          <div class="inseReal-left-title">
            <div class="inseReal-left-title-container">杀虫灯实时数据</div>
          </div>
          <div class="inseReal-left-state">
            <div class="inseReal-left-state-container">设备状态：{{inseDeviceSate}}</div>
          </div>
        </div>
        <div class="inseReal-head-right">
          <div class="inseReal-head-right-container">
            设备名
            <el-select @change="inseRealChange($event)" v-model="inseDevice" filterable >
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in inseOptionList" >
                <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="inseReal-data-content" style="overflow:auto;">
        <div v-for="(row,index) in sliceList(inseDataList, 5)" :key="index" style=" width: 100%;height: 20%;">
          <div class="inseReal-content-body">
            <div class="inseReal-content-bodyContainer"  v-for="(item,i) in row">
              <div class="inseReal-content-container">
                <div class="inseReal-content-containerTr">
                  <div class="inseReal-content-containerTd">{{item.ts}}</div>
                </div>
                <div class="inseReal-content-containerTr">
                  <div class="inseReal-content-containerTd">{{item.name}}</div>
                </div>
                <div class="inseReal-content-containerTr">
                  <div class="inseReal-content-containerTd">{{item.value}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import {getDeviceValue} from "../../until/api/MeteSoil";
  export default {
    name: 'InseRealData',
    components: {},
    computed: {
      sliceList() {
        return function (data,count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i / count);
              if(arrTemp.length <= index) {
                arrTemp.push([])
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      },
    },

    data(){
      return {
        inseOption: [],
        inseOptionList: [],
        inseDeviceJson: {},
        inseDevice: '',
        inseDeviceSate: '-',
        inseDataList: [],
        inseTime: null,
        inseOptionMap: null
      }
    },

    beforeDestroy() {
      clearInterval(this.inseTime);
      this.inseTime = null;
    },

    mounted() {
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;

      let that = this;
      that.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {
        that.soilDeviceBoard(deviceList);
      })
    },

    methods: {
      soilDeviceBoard(response) {
        // if(response.data.length === 0) return;
        // for(let i = 0; i < response.data.length; i++) {
        //   let inseJson = {};
        //   inseJson.id = response.data[i].id.id;
        //   inseJson.name = response.data[i].name;
        //   inseJson.type = response.data[i].id.entityType;
        //   this.inseOption.push(inseJson);
        // }
        // if(this.inseOption.length > 0) {
        //   this.inseDevice = this.inseOption[0].id;
        //   this.inseConnectTime();
        //   this.inseDashInfo();
        // }
        if(response.data.length === 0) return;
        let promises = [];
        for(let i = 0; i < response.data.length; i++) {
          let inseJson = {
            id: response.data[i].id.id,
            name: response.data[i].name,
            type: response.data[i].id.entityType
          };

          let promise = this.$MeteSoilCommon.getLastConnectTime(inseJson.type, inseJson.id).then(time => {
            let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
            inseJson.state = time < beforeTime ? 'red': 'green';
            return inseJson;
          })

          promises.push(promise);
        }

        Promise.all(promises).then(result => {
          this.inseOption = result;
          this.inseOptionMap = null;
          this.inseOptionMap = new Map(this.inseOption.map(item => [item.id, item]));
          if(this.inseOption.length > 0) {
            this.inseDeviceInfo(0, this.inseOption.length);
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      inseDeviceInfo(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.inseOption[j].id, function (deviceInfo) {
          that.inseOption[j].deviceInfo = deviceInfo;
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {
            that.inseDeviceOption(j, keyData);
            if(++j < length) {
              that.inseDeviceInfo(j, length);
            }
          })
        })
      },

      inseDeviceOption(j, keyData) {
        let strKey = '';
        let keyList = keyData.split(',');
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('fxd_') >= 0) {
            strKey += keyList[i] + ',';
          }
        }

        if(strKey != '') {
          this.inseOptionList.push(this.inseOption[j]);

          if(this.inseDevice == '') {
            this.inseDevice = this.inseOptionList[0].id;
            this.inseDeviceJson = this.inseOptionList[0].deviceInfo;
            //获取设备最后一次连接时间
            this.inseConnectTime();
            //根据选中的设备获取设备数据
            this.inseDashInfo();
          }
        }
      },

      inseRealChange(event) {
        this.inseDevice = event;
        clearInterval(this.inseTime);
        this.inseTime = null;
        for(let i = 0; i < this.inseOptionList.length; i++) {
          if(this.inseOptionList[i].id == this.inseDevice) {
            this.inseDeviceJson = this.inseOptionList[i].deviceInfo;
            this.inseConnectTime();
            this.inseDashInfo();
            break;
          }
        }
      },

      inseDashInfo() {
        let that = this;
        this.$MeteSoilCommon.getDeviceKeyList(this.inseDeviceJson, function (keyData) {
          that.inseDeviceKeys(keyData);
        });

        this.inseTime = window.setInterval(() => {
          setTimeout(() => {
            this.$MeteSoilCommon.getDeviceKeyList(this.inseDeviceJson, function (keyData) {
              that.inseDeviceKeys(keyData);
            })
          }, 0)
        }, 1000 * 60)
      },

      inseDeviceKeys(keyData) {
        let keyList = keyData.split(",");
        let strKey = '';
        //筛选出墒情属性
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('fxd_') >= 0) {
            i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ',';
          }
        }
        //获取设备value
        if(strKey != '') {
          this.inseDeviceValues(strKey);
        } else {
          this.soilDataList = [];
        }
      },

      inseDeviceValues(strKey) {
        let inseResponse = [];
        getDeviceValue(this.inseDeviceJson.entityType, this.inseDeviceJson.id, strKey).then(response => {
          for(let obj in response.data) {
            for(let i = 0; i < response.data[obj].length; i++) {
              let inseValue = {};
              inseValue.name = obj;
              inseValue.ts = response.data[obj][i].ts;
              inseValue.value = parseFloat(response.data[obj][i].value);
              inseResponse.push(inseValue);
            }
          }

          inseResponse.sort(function (a, b) {
            return b.ts < a.ts ? -1 : 1;
          });

          this.inseDataList = [];
          for(let i = 0; i < inseResponse.length; i++) {
            let inseValue = {};
            inseValue.ts = this.$commonFun.dateFormat(inseResponse[i].ts);
            inseValue.name = this.$t(inseResponse[i].name).split(',')[0];
            if(inseResponse[i].name == 'fxd_fanMode' || inseResponse[i].name == 'fxd_uvMode') {
              inseValue.value = inseResponse[i].value == 1 ? '开启' : '关闭';
            } else {
              inseValue.value = this.$t(inseResponse[i].name).split(",")[1] === undefined ?
                inseResponse[i].value : inseResponse[i].value + this.$t(inseResponse[i].name).split(",")[1];
            }

            this.inseDataList.push(inseValue);
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      inseConnectTime() {
        let option = this.inseOptionMap.get(this.inseDevice);
        if (option) {
          this.inseDeviceSate = option.state === 'red' ? '离线' : '在线';
        } else {
          // 如果没有找到对应的 id，设置默认值
          this.inseDeviceSate = '离线';
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../less/InseRealData";
</style>

<style>
  .inseReal-data-content::-webkit-scrollbar {
    display: none;
  }

  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>>



// WEBPACK FOOTER //
// src/components/view/InseRealData.vue